import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { ChargeItemListScreen } from 'screens/charge-item';

export default withPermissions(ChargeItemListScreen, [
  GroupSecurity.ChargeItemRead,
]);
